import { api_host } from '../../common/globals/constants';

export const getAudioList = (objective, begin, final, token, monitorId) =>
    fetch(api_host + `/reporte/general/objetivos/${objective}/audios_ivr/list_audios/?token=${token}&fecha_inicio=${begin}&fecha_termino=${final}&monitor=${monitorId}`)
        .then(response => response.json());
